// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"526":"cf454081","764":"426b1b91","845":"4a184c0d"}[chunkId] + ".chunk.css";
};